var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-chart-1"},[_c('div',{staticClass:"lc1-header"},[_vm._v("运单运输情况")]),_c('div',{staticClass:"lc1-details"},[_vm._v("运单总数"),_c('span',[_vm._v(_vm._s(_vm.businessCount.totleCount))])]),_c('dv-capsule-chart',{staticClass:"lc1-chart",attrs:{"config":_vm.config}}),_c('dv-decoration-2',{staticStyle:{"height":"10px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }